/** @jsx jsx */

import { MouseEvent } from 'react';
import { jsx } from '@emotion/core';

import { LegacyButton } from '@zapier/design-system';

type Props = {
  onClick: (event: MouseEvent) => void;
};

const VersioningHelpButton = ({ onClick }: Props) => {
  return (
    <LegacyButton color="secondary" iconBefore="navHelpFill" onClick={onClick}>
      What is versioning?
    </LegacyButton>
  );
};

export default VersioningHelpButton;
